/**
 * Safety setting to turn-off throttle cart/checkout API on FE
 */
export const ENABLE_CART_CHECKOUT_THROTTLE = 'ENABLE_CART_CHECKOUT_THROTTLE';
